import React, { useEffect, useState } from "react";
import HeaderCustom from "../../components/header/HeaderCustom";
import { ButtonStyleAzul, ButtonStyleWhite, CentrarDiv, CustomBackdrop, DivBackgroundDasboard, PaperStyle, TEXT_COLOR_AZUL_OSCURO, TEXT_COLOR_CELESTE, TypographyStyleSecundary } from "../../styles/Styles";
import { Alert, Backdrop, Button, CircularProgress, Container, CssBaseline, IconButton, InputAdornment, Paper, Snackbar, Typography, ListItem, ListItemButton, ListItemText, TextField } from '@mui/material';

const SplashLoading = ({cargando}) => {


    return (
        <CustomBackdrop open={cargando}>
            <CircularProgress color="inherit" />
        </CustomBackdrop>
    )
}

export default SplashLoading;